"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StyledPreview = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _base = _interopRequireDefault(require("../../style/themes/base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const shimmer = (0, _styledComponents.keyframes)`
  0% { opacity:0.1 }
  70% { opacity:0.6 }
  100% { opacity:0.1 }
`;
const PreviewStyle = _styledComponents.default.span`
  animation: ${shimmer} 2s ease infinite;
  background: ${({
  theme
}) => theme.colors.previewBackground};
  display: block;
  height: 15px;
  opacity: 0.6;
  width: 100%;

  & + & {
    margin-top: 3px;
  }
`;
const StyledPreview = _styledComponents.default.div`
  ${_styledSystem.margin}
`;
exports.StyledPreview = StyledPreview;
StyledPreview.defaultProps = {
  theme: _base.default
};
PreviewStyle.defaultProps = {
  theme: _base.default
};
var _default = PreviewStyle;
exports.default = _default;